import React from 'react';
import { SortButton } from '../../../../search/components/sort';
import { PersonSearchProps } from '../../models/arc-epi-props';

interface Props {
    settings: PersonSearchProps;
}
export function PersonSearchLabels(props: Props) {
    const { settings } = props;

    return (
        <div className='employee-search-table-row employee-search-table-sort-row'>
            <div className='employee-search-table-row-cell icon-row-title'>
                <SortButton label={settings?.nameLabel} name='last_name' />
            </div>            
            <div className='employee-search-table-row-cell'>
                <SortButton label={settings?.dobLabel} name='masked_date_of_birth' />
            </div>
            <div className='employee-search-table-row-cell'>
                <SortButton label={settings?.ssnLabel} name='masked_ssn' />
            </div>
            <div className='employee-search-table-row-cell'>
                <strong>{settings?.actionLabel}</strong>
            </div>
        </div>
    );
}